module.exports = __webpack_public_path__ + "static/img/6.d98ca6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/zh/6.png
// module id = 8vFf
// module chunks = 0